import { Configuration } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: "3aeb2cca-6d87-41f5-af9e-a297bf9c5172",
    authority:
      "https://iotonramp.b2clogin.com/tfp/iotonramp.onmicrosoft.com/B2C_1_sign_in_sign_up",
    knownAuthorities: [
      "https://iotonramp.b2clogin.com/tfp/iotonramp.onmicrosoft.com/B2C_1_sign_in_sign_up",
    ],
    redirectUri: "/dashboard",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
